import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ShoppingCartIcon, CoffeeIcon, CheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { CrossSellModal } from './CrossSellModal';
import { SkipButton } from './SkipButton';
import { getBumps, saveBumps, wantsBono1, CART_URLS } from '../../utils/checkoutUrls';
export function Bonus2x1Section() {
  const [selected, setSelected] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const handleToggle = () => {
    const newVal = !selected;
    setSelected(newVal);
    const bumps = getBumps();
    bumps.upsellBump2 = newVal;
    saveBumps(bumps);
  };
  const handleBuy = () => {
    if (wantsBono1()) {
      window.open(CART_URLS.allBonuses, '_blank');
    } else {
      setShowModal(true);
    }
  };
  return <div className="flex flex-col h-full" data-id="element-260">
      <div className="flex-1 flex flex-col" data-id="element-261">
        <motion.div className="bg-white rounded-3xl shadow-soft-xl border-2 border-terracotta/20 relative overflow-hidden flex-1 flex flex-col" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-262">
          <div className="bg-gradient-to-r from-terracotta to-gold-soft text-white text-center py-3 font-semibold tracking-widest uppercase text-sm" data-id="element-263">
            Oferta Especial 2x1
          </div>

          <div className="p-6 md:p-8 flex-1 flex flex-col" data-id="element-264">
            <div className="text-center mb-4" data-id="element-265">
              <span className="inline-block px-4 py-1.5 rounded-full bg-sage/10 text-sage font-semibold text-sm tracking-wide mb-3" data-id="element-266">
                BONOS 2 + 3
              </span>
              <h2 className="text-2xl md:text-3xl font-heading font-semibold text-text-dark" data-id="element-267">
                Lista de Compras + 15 Bebidas
              </h2>
            </div>

            <div className="mb-5 flex justify-center" data-id="element-268">
              <img src="https://cdn.magicpatterns.com/uploads/uNz4Pm2qUGKcGCt7U2xDJ1/ChatGPT_Image_11_mar_2026,_11_40_53_p.m..png" alt="Pack 2x1: Bebidas y Lista de Compras" className="w-full h-64 rounded-xl shadow-md object-cover" data-id="element-269" />
            </div>

            <p className="text-text-medium text-center text-sm mb-4 max-w-md mx-auto" data-id="element-270">
              Complementa tu plan con una lista de compras organizada y 15
              bebidas naturales anti-inflamatorias.
            </p>

            <div className="flex flex-wrap justify-center gap-2 mb-5" data-id="element-271">
              {['Lista organizada', 'Bebidas naturales', '2x1 especial'].map((item, idx) => <span key={idx} className="flex items-center gap-1.5 text-xs font-medium text-text-dark bg-sage-50 px-3 py-1.5 rounded-full" data-id="element-272">
                    <CheckIcon className="w-3.5 h-3.5 text-sage flex-shrink-0" strokeWidth={2.5} data-id="element-273" />
                    {item}
                  </span>)}
            </div>

            <div className="flex flex-col gap-3 mb-6 max-w-lg mx-auto" data-id="element-274">
              <div className="flex items-center gap-3 bg-cream rounded-xl p-3 border border-beige" data-id="element-275">
                <ShoppingCartIcon className="w-5 h-5 text-sage flex-shrink-0" strokeWidth={1.5} data-id="element-276" />
                <div className="flex-1 min-w-0" data-id="element-277">
                  <span className="text-xs text-sage font-semibold tracking-wider" data-id="element-278">
                    BONO 2
                  </span>
                  <h3 className="text-sm font-heading font-semibold text-text-dark leading-tight" data-id="element-279">
                    Lista de Compras Anti-Inflamatoria
                  </h3>
                </div>
              </div>
              <div className="flex items-center gap-3 bg-cream rounded-xl p-3 border border-beige" data-id="element-280">
                <CoffeeIcon className="w-5 h-5 text-sage flex-shrink-0" strokeWidth={1.5} data-id="element-281" />
                <div className="flex-1 min-w-0" data-id="element-282">
                  <span className="text-xs text-sage font-semibold tracking-wider" data-id="element-283">
                    BONO 3
                  </span>
                  <h3 className="text-sm font-heading font-semibold text-text-dark leading-tight" data-id="element-284">
                    15 Bebidas Naturales Anti-Inflamatorias
                  </h3>
                </div>
              </div>
            </div>

            <div className="flex flex-col items-center text-center max-w-md mx-auto mt-auto" data-id="element-285">
              <div className="mb-1 text-sm" data-id="element-286">
                <span className="text-text-medium" data-id="element-287">Antes: </span>
                <span className="line-through text-text-light font-medium" data-id="element-288">
                  $98
                </span>
              </div>

              <span className="text-5xl font-heading font-bold text-terracotta mb-1" data-id="element-289">
                Hoy solo $9
              </span>

              <p className="text-olive font-medium text-sm mb-5" data-id="element-290">
                Dos guías por el precio de una
              </p>

              <div onClick={handleToggle} className={`w-full flex items-center justify-center gap-3 py-4 px-6 rounded-xl cursor-pointer transition-all duration-300 border-2 ${selected ? 'bg-sage text-white border-sage shadow-lg' : 'bg-white text-text-dark border-terracotta hover:bg-terracotta/5'}`} data-id="element-291">
                <div className={`w-6 h-6 rounded-md flex-shrink-0 flex items-center justify-center border-2 transition-colors ${selected ? 'bg-white border-white' : 'border-terracotta bg-white'}`} data-id="element-292">
                  {selected && <CheckIcon className="w-4 h-4 text-sage" strokeWidth={3} data-id="element-293" />}
                </div>
                <span className="font-semibold text-lg" data-id="element-294">
                  {selected ? '¡Añadido! ✓' : 'Sí, quiero ambos bonos por $9'}
                </span>
              </div>

              <CTAButton text="Comprar ahora" variant="primary" className={`w-full mt-3 text-lg py-4 shadow-xl shadow-terracotta/30 ${!selected ? 'opacity-40 pointer-events-none' : ''}`} onClick={handleBuy} data-id="element-295" />
            </div>
          </div>
        </motion.div>
      </div>

      <CrossSellModal isOpen={showModal} emoji="🍽️" title="¡Espera! ¿Quieres agregar las 25 Recetas Anti-Inflamatorias por solo $9 más?" description="Complementa tu plan con recetas deliciosas y fáciles de preparar." declineText="No gracias, solo quiero estos bonos" onAccept={() => {
      setShowModal(false);
      window.open(CART_URLS.allBonuses, '_blank');
    }} onDecline={() => {
      setShowModal(false);
      window.open(CART_URLS.bono23Only, '_blank');
    }} data-id="element-296" />
    </div>;
}